import { Outlet } from "@tanstack/react-router";

import { Beian } from "@/features/shared/components/beian";
import { ContactUs } from "@/features/shared/components/contact-us";
import { Separator } from "@/components/ui/separator";
import { SignInForm } from "@/features/auth/components/sign-in-form";
import { WechatLoginButton } from "@/features/auth/components/wechat-login-button";

export interface AuthRoutePageProps {
  error?: string | undefined;
  isAuthIndex: boolean;
  referralCode?: string | undefined;
}

export function AuthRoutePage({ error, isAuthIndex, referralCode }: AuthRoutePageProps) {
  if (!isAuthIndex) {
    return <Outlet />;
  }

  return (
    <div className="h-svh grid place-items-center">
      <div className="w-full max-w-md px-4">
        {error ? (
          <div className="mb-3 rounded-xl border border-red-500/25 bg-red-500/10 px-3 py-2 text-sm text-red-200">
            {error}
          </div>
        ) : null}

        <SignInForm />

        <div className="mt-4 rounded-xl border border-border/60 bg-card/70 p-4 shadow-sm">
          <div className="relative">
            <div className="absolute inset-0 flex items-center">
              <Separator className="w-full opacity-60" />
            </div>
            <div className="relative flex justify-center text-xs">
              <span className="rounded-full bg-card px-3 text-muted-foreground">
                或使用以下方式登录 / 注册
              </span>
            </div>
          </div>

          <div className="mt-4 space-y-2">
            <WechatLoginButton referralCode={referralCode} />
            {referralCode ? (
              <p className="text-center text-xs text-muted-foreground">
                当前邀请链接已生效，使用微信创建账号后将自动发放邀请奖励
              </p>
            ) : null}
          </div>
        </div>

        <ContactUs />
        <Beian />
      </div>
    </div>
  );
}
